const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
const MAX_PDF_BYTES = 10 * 1024 * 1024;

function isPdfFile(file: File): boolean {
  if (file.type === "application/pdf") return true;
  return file.name.toLowerCase().endsWith(".pdf");
}

function isImageFile(file: File): boolean {
  if (file.type.startsWith("image/")) return true;
  return /\.(jpe?g|png|gif|webp|heic|heif|bmp|tiff?)$/i.test(file.name);
}

/** Returns an error message, or `null` if the file is acceptable. */
export function validatePhase2DocumentFile(file: File): string | null {
  if (isPdfFile(file)) {
    if (file.size > MAX_PDF_BYTES) {
      return "PDF must be 10 MB or smaller.";
    }
    return null;
  }
  if (isImageFile(file)) {
    if (file.size > MAX_IMAGE_BYTES) {
      return "Image must be 5 MB or smaller.";
    }
    return null;
  }
  return "Please upload a PDF or image file.";
}
  